import { createFeatureSelector } from '@ngrx/store';

import { type CollectionsState, COLLECTIONS_FEATURE_KEY } from './collections-feature.reducer';

export const collectionsState = createFeatureSelector<CollectionsState>(COLLECTIONS_FEATURE_KEY);
